import { MouseEventHandler } from "react";
import { NavigateFunction } from "react-router-dom";
import {
  IAPIEstablishment,
  IAPIObjective,
  MarketAction,
  MyliPlatformId,
} from "redux/configuration/configuration.interface";
import { HOME_ROUTES, HomeRoutes } from "utils/constants/router";
import { Marketings } from "./home.types";

const supportedObjectives = new Set<IAPIObjective>([
  IAPIObjective.SELECT_RESTAURANT,
  IAPIObjective.REVIEW_GOOGLE,
  IAPIObjective.FOLLOW_INSTAGRAM,
  IAPIObjective.NEWSLETTER,
  IAPIObjective.NPS,
  IAPIObjective.REFER_FRIEND,
  IAPIObjective.FOLLOW_TWITTER,
  IAPIObjective.GOOGLE_B,
  IAPIObjective.FOLLOW_TIKTOK,
  IAPIObjective.FOLLOW_FACEBOOK,
  IAPIObjective.VISIT_TRIPADVISOR,
  IAPIObjective.DOWNLOAD_APP,
  IAPIObjective.SURVEY,
]);

export const isSupportedHomeObjective = (
  objective: IAPIObjective | undefined
) => objective !== undefined && supportedObjectives.has(objective);

export const searchMarketAction = (
  pid: MyliPlatformId,
  marketActions: MarketAction[]
) => {
  return (
    marketActions?.find(
      (marketAction: MarketAction) => marketAction.pid === pid
    ) || null
  );
};

export const handleCTAClick = (
  navigate: NavigateFunction,
  marketing?: IAPIObjective,
  ets?: IAPIEstablishment[]
): MouseEventHandler => {
  const handler: MouseEventHandler = () => {
    let path = "";

    if (ets?.length) {
      path = HOME_ROUTES.get(HomeRoutes.selectRestaurant).path;
      navigate(path);
      return;
    }

    switch (marketing) {
      case IAPIObjective.SELECT_RESTAURANT:
        path = HOME_ROUTES.get(HomeRoutes.selectRestaurant).path;
        break;
      case IAPIObjective.REVIEW_GOOGLE:
        path = HOME_ROUTES.get(HomeRoutes.google).path;
        break;
      case IAPIObjective.FOLLOW_INSTAGRAM:
        path = HOME_ROUTES.get(HomeRoutes.instagram).path;
        break;
      case IAPIObjective.NEWSLETTER:
        path = HOME_ROUTES.get(HomeRoutes.newsletter).path;
        break;
      case IAPIObjective.NPS:
        path = HOME_ROUTES.get(Marketings.nps).path;
        break;
      case IAPIObjective.REFER_FRIEND:
        path = HOME_ROUTES.get(Marketings.referral).path;
        break;
      case IAPIObjective.FOLLOW_TWITTER:
        path = HOME_ROUTES.get(Marketings.twitter).path;
        break;
      case IAPIObjective.GOOGLE_B:
        path = HOME_ROUTES.get(Marketings.googlePlace).path;
        break;
      case IAPIObjective.FOLLOW_TIKTOK:
        path = HOME_ROUTES.get(HomeRoutes.tiktok).path;
        break;
      case IAPIObjective.FOLLOW_FACEBOOK:
        path = HOME_ROUTES.get(HomeRoutes.facebook).path;
        break;
      case IAPIObjective.VISIT_TRIPADVISOR:
        path = HOME_ROUTES.get(HomeRoutes.tripAdvisor).path;
        break;
      case IAPIObjective.DOWNLOAD_APP:
        path = HOME_ROUTES.get(HomeRoutes.downloadApp).path;
        break;
      case IAPIObjective.SURVEY:
        path = HOME_ROUTES.get(HomeRoutes.survey).path;
        break;
    }
    if (path) {
      navigate(path);
    }
  };

  return handler;
};
